import { put, select, takeEvery } from "redux-saga/effects";
import { actions, selectors } from "redux-store";
import { GameStatus } from "redux-store/slices/game/game.interfaces";

export function* playSoundSaga() {
  yield takeEvery(actions.playSound, function* (action) {
    try {
      const sound = document.getElementById(
        action.payload.audioId,
      ) as HTMLAudioElement;
      sound.pause();
      sound.currentTime = 0;
      sound.play();
      if (action.payload.getHandler) {
        sound.pause();
      }
    } catch (e) {
      console.error(e);
    }
  });
}

export function* onTileRotatedSaga() {
  yield takeEvery(actions.rotateTile, checkGameCompletion);
  yield takeEvery(actions.fixTile, checkGameCompletion);
}

function* checkGameCompletion() {
  const rotations = yield select(selectors.getRotations);
  const allTilesSet = rotations.reduce(
    (isComplete, currentTile) => isComplete && currentTile.turns % 4 === 0,
    true,
  );

  if (allTilesSet) {
    yield put(actions.setGameStatus(GameStatus.SUCCESS));
    yield put(actions.playSound("winAudioId"));
  }
}
